import { useCallback, useEffect, useRef, useState } from "react";

type NavigateSessionProps = {
    data: any[];
    onGetIdSession: (sessionId: number) => void;
};

function NavigateSession({ data, onGetIdSession }: NavigateSessionProps) {
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const isInitialized = useRef(false);

    const handleChooseSession = useCallback(
        (index: number, sessionId: number) => {
            setCurrentIndex(index);
            onGetIdSession(sessionId);
        },
        [onGetIdSession]
    );

    // ✅ chỉ auto chọn session đầu tiên MỘT LẦN
    useEffect(() => {
        if (!isInitialized.current && data.length > 0) {
            isInitialized.current = true;
            handleChooseSession(0, data[0].id);
        }
    }, [data, handleChooseSession]);

    return (
        <div className="border border-[#e0e0e0] divide-y divide-[#e0e0e0] min-h-[300px] h-fit">
            {data.map((session: any, index: number) => (
                <div
                    key={session.id}
                    onClick={() => handleChooseSession(index, session.id)}
                    className={`${currentIndex === index ? "bg-secondary text-white" : ""
                        } py-[8px] hover:text-white hover:bg-secondary hover:opacity-70 cursor-pointer flex justify-center items-center`}
                >
                    <span className="font-bold">Buổi {index + 1}</span>
                </div>
            ))}
        </div>
    );
}

export default NavigateSession;
